import React from 'react'
import PropTypes from 'prop-types'
import Button from '#components/a/Button'
import Loading from '#components/a/Loading'

export function LoadingButton(props) {
  const text = (props.isLoading && props.loadingText) || props.text

  return (
    <div
      data-testid="loading-button-wrapper"
      className={props.isLoading ? 'loading-button loading-button--loading' : 'loading-button'}
    >
      {props.isLoading && <Loading />}
      <Button {...props} disabled={props.disabled || props.isLoading} text={text} />
    </div>
  )
}

LoadingButton.propTypes = {
  ...Button.propTypes,
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
}
